require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-classically-trained-which-modern-cars-will-be-retro-icons-in-2040.json") })
        }
      }, "path---authors-classically-trained-which-modern-cars-will-be-retro-icons-in-2040");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-classically-trained-which-modern-cars-will-be-retro-icons-in-2040!./.cache/json/authors-classically-trained-which-modern-cars-will-be-retro-icons-in-2040.json
// module id = 1265
// module chunks = 231608221292675